import { PermissionKey } from "~/types/Permissions";

export const hasGetGroupsPermissionForNameWithTypeCheck = (
  name: string,
  hasPermission: (key: PermissionKey) => boolean,
) => {
  const value = (name || "").toLowerCase().trim();

  if (value === "зона сервиса")
    return hasPermission("ivideonGroups.getGroups.service");

  if (value === "зона продаж")
    return hasPermission("ivideonGroups.getGroups.sale");

  return true;
};
